document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('[id^="collection-tabbing-"]');

    sections.forEach(section => {
        const tabs = section.querySelectorAll('.nav-link');
        const contents = section.querySelectorAll('.tab-content');
        const swipers = [];

        function deactivateAllTabs() {
            tabs.forEach(tab => tab.classList.remove('active'));
            contents.forEach(content => content.style.display = 'none');
        }

        function activateTab(tab) {
            const tabId = tab.getAttribute('data-tab');
            const content = section.querySelector(`#${tabId}`);

            tab.classList.add('active');
            content.style.display = 'block';

            const swiperContainer = content.querySelector('.swiper-products');

            const updateArrowVisibility = (swiperInstance) => {
                const totalSlides = swiperInstance.slides.length;
                const slidesPerView = swiperInstance.params.slidesPerView;

                const nextButton = content.querySelector('.collection-swiper-button-next');
                const prevButton = content.querySelector('.collection-swiper-button-prev');

                if (totalSlides <= slidesPerView) {
                    nextButton.style.display = 'none';
                    prevButton.style.display = 'none';
                } else {
                    nextButton.style.display = 'block';
                    prevButton.style.display = 'block';
                }
            };

            if (swiperContainer.swiper) {
                swiperContainer.swiper.update();
                updateArrowVisibility(swiperContainer.swiper);
                updateCenterSlides(swiperContainer.swiper);

            } else {
                const swiperInstance = new Swiper(swiperContainer, {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 30,
                    navigation: {
                        nextEl: content.querySelector('.collection-swiper-button-next'),
                        prevEl: content.querySelector('.collection-swiper-button-prev'),
                    },
                    scrollbar: {
                        el: content.querySelector('.swiper-scrollbar'),
                        draggable: true,
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 1.6,
                            spaceBetween: 15,
                        },
                        450: {
                            slidesPerView: 2,
                        },
                        640: {
                            slidesPerView: 2.5,
                        },
                        769: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                    },
                });

                swipers.push(swiperInstance);
                updateArrowVisibility(swiperInstance);
                updateCenterSlides(swiperInstance);
            }
        }

        tabs.forEach(tab => {
            tab.addEventListener('click', function () {
                deactivateAllTabs();
                activateTab(this);
            });
        });

        if (tabs.length > 0) {
            deactivateAllTabs();
            activateTab(tabs[0]);
        }
    });
  });


  function updateCenterSlides(swiperInstance) {
    const slides = swiperInstance.slides.length;
    const slidesPerView = swiperInstance.params.slidesPerView;
    const swiperContainer = swiperInstance.el; // Get the swiper container

    if (slides < slidesPerView) {
        swiperContainer.classList.add("center-slides");
    } else {
        swiperContainer.classList.remove("center-slides");
    }
}
